module.exports = __webpack_public_path__ + "static/media/pic-ht14.09f0093d.jpg";